import { useEffect, useRef } from 'react';
import { Doughnut } from 'react-chartjs-2';

import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";

// Register the required Chart.js components
ChartJS.register(ArcElement, Tooltip, Legend);

const DonutChart = ( { chartData } ) => {
  if (!chartData){
    return (<div>Loading...</div>)
  }
  const graphLabels = Object.keys(chartData);
  const graphVals = Object.values(chartData);

  const inputData = {
    labels: graphLabels,
    datasets: [
      {
        //label: "Votes",
        data: graphVals,
        backgroundColor: [
          "rgba(255, 99, 132, 0.6)",
          "rgba(54, 162, 235, 0.6)",
          "rgba(255, 206, 86, 0.6)",
          "rgba(75, 192, 192, 0.6)",
          "rgba(153, 102, 255, 0.6)",
        ],
        borderColor: [
          "rgba(255, 99, 132, 1)",
          "rgba(54, 162, 235, 1)",
          "rgba(255, 206, 86, 1)",
          "rgba(75, 192, 192, 1)",
          "rgba(153, 102, 255, 1)",
        ],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: true, // not working
        position:"right", // not working
         labels: {color: 'rgb(255, 99, 132)'}
      },
          tooltip: {
        enabled: true,
      },
    },
    cutout: "50%", // Makes it a donut
    radius:"100%"
  };

  return (
    <Doughnut data={inputData} options={options} />
  );
};

export default DonutChart;